module.exports = __webpack_public_path__ + "img/357.0192d430.jpg";